export default __webpack_public_path__ + "static/Solideo-4a76945c6964a5ab2bff29ae503e31c0.jpg";